import { useContext, useEffect } from 'react';
import { TrackerPromptData, PromptsViewedTrackerContext } from './promptsViewedContext';

/**
 * Хук для регистрации карточки промпта в обсервере просмотренных промптов
 */
export const usePromptCardVisibility = (
    promptCardRef: React.RefObject<HTMLDivElement | null>,
    data: TrackerPromptData,
) => {
    const observer = useContext(PromptsViewedTrackerContext);

    useEffect(() => {
        if (!promptCardRef.current) {
            return;
        }

        const elementRef = promptCardRef.current;
        observer?.observe(elementRef, data);

        return () => observer?.unobserve(elementRef);
    }, [observer, data, promptCardRef]);
};
